// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal_Modal_1Udcx"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Modal/Modal.css
// module id = 318
// module chunks = 4